/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

class PDPs {
    PDPMap = new Map();

    AppLanguagesMap = new Map();

    // key = sapcode
    getPDP(key) {
        return this.PDPMap.get(key);
    }

    setPDP(key, pdpObject) {
        this.PDPMap.set(key, pdpObject);
    }

    setAppLanguages(sapcode, languageList) {
        this.AppLanguagesMap.set(sapcode, languageList);
    }

    getAppLanguages(sapcode) {
        return this.AppLanguagesMap.get(sapcode);
    }
}

export default new PDPs();
